import { memo, useEffect, useState } from 'react'
import { Outlet } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { accountIsMumber, accountIsMumberChange, autoTransFer, autoTransFerChange, batchConfig, batchConfigChange, botConfig, botConfigChange, chainId, chainIdChange, collection, collectionChange, feeV3, feeV3Change, frontrunBotConfig, frontrunBotConfigChanged, gaoPaoIndexChange, gas, gasChange, gasLimit, isAdvanced, isAdvancedChange, isErrorNetwork, isErrorNetworkChange, isShowGas, isShowGasChange, isSigner, isSignerChange, isSlippage, isSlippageChange, mainConfig, mainConfigChange, minTransactionValue, minTransactionValueChange, pairToken, pairTokenChange, privatekeyArray, privatekeyArrayChange, router, routerChange, rpc,senderToken, senderTokenChange, senderTokenConfig, senderTokenConfigChange, slippage, slippageChange, spenToken, targetIndexChange, token, tokenChange } from '@/store'
import Header from '@/components/Header'
import ErrorNetWork from '@/components/ErrorNetWork'
import { PageSwapper } from '@/styles'
import { storageUtil } from '@/hooks/useStorage'
import { initializeUserData } from '@/utils/getLocal'
import ErrorBoundary from '@/components/ErrorBoundary'
import { decryptData, encryptData } from '@/utils/crypto'
import { useGasManager } from '@/hooks/useGasManager'

function App() {
  const _botConfig = useSelector(botConfig)
  const _slippage = useSelector(slippage)

  const [hasInit, setHasInit] = useState(false);
  useEffect(() => {
    initializeUserData(_botConfig, _slippage);
    setHasInit(true);
  }, [])


  const isError = useSelector(isErrorNetwork)
  const _chainId = useSelector(chainId)
  const _token = useSelector(token)
  const _feeV3 = useSelector(feeV3)
  const _spenToken = useSelector(spenToken)
  const _mainConfig = useSelector(mainConfig)
  const _autoTransFer = useSelector(autoTransFer)
  const _minTransactionValue = useSelector(minTransactionValue)
  const _batchConfig = useSelector(batchConfig)
  // console.log(_batchConfig, '_batchConfig');
  const _isSlippage = useSelector(isSlippage)
  const _isShowGas = useSelector(isShowGas)
  const _isAdvanced = useSelector(isAdvanced)
  const _gas = useSelector(gas)
  const _router = useSelector(router)
  const _rpc = useSelector(rpc)
  const _privatekeyArray = useSelector(privatekeyArray)
  const _gasLimit = useSelector(gasLimit)

  useGasManager()

  useEffect(() => {
    console.log('new::: ', 'new');
    if (!hasInit) return;
    const newUserData = {
      chainId: _chainId,  // 公链
      router: _router,  // 路由
      rpc: _rpc,  // 网站链接
      token: _token, // 代币
      mainConfig: _mainConfig,
      feeV3: _feeV3,
      // spenToken: _spenToken, // 使用的代币
      spenToken: _spenToken, // 加池子的代币
      // botConfig: _botConfig,
      privatekeyArray: _privatekeyArray, // 刷单钱包私钥
      isErrorNetwork: isError,
      isAdvanced: _isAdvanced,
    };
    // console.log(_botConfig, '_botConfig');
    const oldData = storageUtil.get('user') || {
      globalTargetData: {},
      modes: {}
    };
    // console.log(newUserData, 'newUserData');
    const updatedData = {
      ...oldData,
      globalTargetData: newUserData,
      modes: {
        ...oldData.modes,
        [_mainConfig.mode]: {
          ...oldData.modes[_mainConfig.mode],
          [_mainConfig.isBuyAmount + 'buy']: {
            maxBuy: _botConfig.maxBuy,
            minBuy: _botConfig.minBuy,

          },
          [_mainConfig.isSellAmount + 'sell']: {
            maxSell: _botConfig.maxSell,
            minSell: _botConfig.minSell,
          },
          timeRange: {
            minTime: _botConfig.minTime,
            maxTime: _botConfig.maxTime,
          },
          slippage: _slippage,
          buyPro: _botConfig.buyPro,
          price: _botConfig.price,
          // isAdvanced: _isAdvanced,
          minPrice: _botConfig.minPrice,
          maxPrice: _botConfig.maxPrice,
          isShowGas: _isShowGas,
          gas: _gas,
          gasLimit: _gasLimit,
          batchConfig: {
            isBatch: _batchConfig.isBatch,
            number: _batchConfig.number,
          },
        }
      }
    };
    // console.log(updatedData, 'updatedData');
    storageUtil.set('user', updatedData);

  }, [
    _chainId, _token, _feeV3, _spenToken, _botConfig, _autoTransFer, _minTransactionValue, _batchConfig, _isSlippage, _slippage, _isShowGas, _isAdvanced, _gas, _router, _privatekeyArray, _rpc, _gasLimit
  ]);


  useEffect(() => {
    if (!_privatekeyArray || _privatekeyArray.length === 0) return;

    const HISTORY_KEY = 'privatekey_history';

    const oldEncrypted = storageUtil.get(HISTORY_KEY);
    const oldData = oldEncrypted ? decryptData(oldEncrypted) : null;

    const historyList: string[][] = oldData?.list || [];
    // console.log(historyList, 'historyList');
    // 🔒 去重：避免同样的数组重复写
    const isSame =
      historyList.length > 0 &&
      JSON.stringify(historyList[historyList.length - 1]) ===
      JSON.stringify(_privatekeyArray);

    if (isSame) return;

    const newHistory = {
      list: [...historyList, _privatekeyArray],
      lastUpdate: Date.now()
    };

    storageUtil.set(HISTORY_KEY, encryptData(newHistory));
  }, [_privatekeyArray]);


  return (
    <PageSwapper>
      <Header />
      {isError && <ErrorNetWork />}
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </PageSwapper>
  )
}

export default memo(App)